module.exports = __webpack_public_path__ + "img/SDG_03-deactivated.590a7802.png";